import { queryOptions } from '@tanstack/react-query';

import { getSystemConfigRequest } from './system.requests';

export const getSystemConfigOptions = () =>
  queryOptions({
    queryFn: () => getSystemConfigRequest(),
    queryKey: ['system-config'],
  });
